const mapBox = document.getElementById('map');
if (mapBox) {
  const points = [];
  const modalBoxText = document.querySelector('.modal__body .modal__content .editor-text h3');
  const urlOsrmNearest = '//router.project-osrm.org/nearest/v1/driving/';
  const urlOsrmRoute = '//router.project-osrm.org/route/v1/driving/';
  const vectorSource = new ol.source.Vector();
  const vectorLayer = new ol.layer.Vector({
    source: vectorSource,
  });
  const styles = {
    route: new ol.style.Style({
      stroke: new ol.style.Stroke({
        width: 4,
        color: [235, 125, 45],
        lineDash: [5, 7],
      }),
    }),
    icon_enter: new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 1],
        src: mapBox.dataset.icon_enter,
        scale: 0.8,
      }),
    }),
    icon_destination: new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 1],
        src: mapBox.dataset.icon_destination,
        scale: 0.9,
      }),
    }),
  };
  const view = new ol.View({
    center: [1669388, 5807245],
    zoom: 8.6,
  });
  const map = new ol.Map({
    target: 'map',
    layers: [
      new ol.layer.Tile({
        className: 'bw',
        source: new ol.source.OSM(),
      }),
      vectorLayer,
    ],
    view,
  });
  const utilsMap = {
    addEventOnTabToResetMap: () => {
      attachEvent('[data-tab]', 'click', () => {
        document.querySelectorAll('.tab-module__item').forEach((item) => {
          if (item.querySelector('.sc-location-module') && item.classList.contains('is-active')) {
            utilsMap.resetMap();
          }
        });
      });
    },
    openRemoveModal: (remove) => {
      const modalEle = document.querySelector('.mod-map .modal');
      if (remove) {
        modalEle.classList.remove('is-open-modal');
      } else {
        modalEle.classList.add('is-open-modal');
      }
    },
    getZoomNumber: (number) => {
      let zoom = 8.8;
      if (number < 15000) {
        zoom = 12.6;
      } else if (number < 20000) {
        zoom = 12.2;
      } else if (number < 30000) {
        zoom = 11.1;
      } else if (number < 40000) {
        zoom = 10.9;
      } else if (number < 50000) {
        zoom = 10.7;
      } else if (number < 60000) {
        zoom = 10.2;
      } else if (number < 100000) {
        zoom = 9.8;
      }
      return zoom;
    },
    getNearest: (coord) =>
      new Promise((resolve, reject) => {
        fetch(urlOsrmNearest + utilsMap.to4326(coord).join())
          .then((response) => response.json())
          .then((json) => {
            if (json.code === 'Ok') {
              resolve(json.waypoints[0].location);
            } else {
              reject();
            }
          });
      }),
    removeFuture: () => {
      const features = vectorSource.getFeatures();
      for (let i = 1; i < features.length; i += 1) {
        vectorSource.removeFeature(features[i]);
      }
    },
    timeConvert: (n) => {
      const hours = n / 60;
      const rHours = Math.floor(hours);
      const rMinutes = Math.round((hours - rHours) * 60);
      let textHours = mapBox.dataset.morehours;
      if (rHours === 1) {
        textHours = mapBox.dataset.onehour;
      } else if (rHours === 2) {
        textHours = mapBox.dataset.twohours;
      } else if (rHours === 3 || rHours === 4) {
        textHours = mapBox.dataset.threehours;
      }
      let textMinutes = mapBox.dataset.moreminutes;
      if (rMinutes === 1) {
        textMinutes = mapBox.dataset.oneminute;
      } else if (rMinutes === 2) {
        textMinutes = mapBox.dataset.twominutes;
      } else if (rMinutes === 3 || rMinutes === 4) {
        textMinutes = mapBox.dataset.threeminutes;
      }
      return `${rHours} ${textHours}, ${rMinutes} ${textMinutes}.`;
    },
    createFeature: (coord, isFirst) => {
      clearInterval(window.intervalToResetMap);
      const feature = new ol.Feature({
        type: 'place',
        geometry: new ol.geom.Point(ol.proj.fromLonLat(coord)),
      });
      feature.setStyle(isFirst ? styles.icon_destination : styles.icon_enter);
      vectorSource.addFeature(feature);
      utilsMap.setIntervalForReset();
    },
    resetMap: () => {
      utilsMap.removeFuture();
      view.animate({
        center: [1669388, 5807245],
        zoom: 8.6,
      });
      utilsMap.openRemoveModal(true);
    },
    setIntervalForReset: () => {
      window.intervalToResetMap = setInterval(() => {
        if (vectorSource.getFeatures().length > 1) {
         utilsMap.resetMap();
        }
      }, 180000);
    },
    animateCallBack: (complete) => {
      if (complete) {
        setTimeout(() => {
          utilsMap.openRemoveModal(false);
        }, 1000);
      }
    },
    createRoute: (polyline) => {
      const route = new ol.format.Polyline({
        factor: 1e5,
      }).readGeometry(polyline, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
      });
      const feature = new ol.Feature({
        type: 'route',
        geometry: route,
      });
      feature.setStyle(styles.route);
      vectorSource.addFeature(feature);
    },
    to4326: (coord) => ol.proj.transform([parseFloat(coord[0]), parseFloat(coord[1])], 'EPSG:3857', 'EPSG:4326'),
  };
  setTimeout(() => {
    const pinLatLng = [mapBox.dataset.lng, mapBox.dataset.lat];
    points.push(pinLatLng);
    utilsMap.createFeature(pinLatLng, true);
  }, 200);
  map.on('click', (evt) => {
    utilsMap.getNearest(evt.coordinate).then((coordStreet) => {
      const centerPoint = ol.proj.transform(
        [(coordStreet[0] + Number(mapBox.dataset.lng)) / 2, (coordStreet[1] + Number(mapBox.dataset.lat)) / 2],
        'EPSG:4326',
        'EPSG:3857',
      );
      view.animate({
        center: centerPoint,
      });
      const lastPoint = points[points.length - 1];
      fetch(`${urlOsrmRoute}${lastPoint.join()};${coordStreet.join()}`)
        .then((r) => r.json())
        .then((json) => {
          const hourAndMin = (json.routes[0].distance / 1000 / 8) * 60;
          modalBoxText.innerHTML = `${mapBox.dataset.prefix} ${utilsMap.timeConvert(hourAndMin)}`;
          utilsMap.removeFuture();
          utilsMap.createFeature(coordStreet, false);
          utilsMap.createRoute(json.routes[0].geometry);
          view.animate({
            center: centerPoint,
            duration: 500,
            zoom: Number(utilsMap.getZoomNumber(json.routes[0].distance)),
          }, utilsMap.animateCallBack);
        });
    });
  });
  utilsMap.addEventOnTabToResetMap();
}
